// Form validation for New Milestone form
import { plaintextValidator, dropdownValidator } from '../fields';
import { stringMandateConstraints } from '../utils';

const config = { mandatory: true };

export default {
  name: plaintextValidator(config),
  language: dropdownValidator(config),
  runAs: dropdownValidator(config),
  timeOut: {
    presence: { mandatory: true },
    equality: {
      attribute: 'name',
      message: '^Timeout cannot be less than 1',
      comparator: function(v1, v2) {
        if (parseFloat(v1) < 1) {
          return false;
        }
        return true;
      }
    }
  },
  runTimeVariables: {
    array: {
      name: stringMandateConstraints
    }
  },
  placeholderVariables: {
    array: {
      name: stringMandateConstraints,
      labelName: stringMandateConstraints
    }
  },
  additionalFiles: {
    array: {
      destinationLocation: stringMandateConstraints
    }
  }
};
